import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";

import "@/core/plugins/prismjs";
import "bootstrap";
import GlobalComponents from "@/components/global/index";
import itIT from 'element-plus/es/locale/lang/it'
import { it } from "yup-locales";
import { setLocale } from "yup";
import dayjs from "dayjs";
require("dayjs/locale/it");

import { setupCalendar, Calendar, DatePicker } from 'v-calendar';
import 'v-calendar/style.css';

declare global {
    interface Array<T> {
        includes<U extends (T extends U ? unknown : never)>(
            searchElement: U, fromIndex?: number): boolean;
    }
}

const app = createApp(App);
app.config.globalProperties.console = console
Object.keys(GlobalComponents).forEach((fileName) => {
    // Regoster all global components for intellij

    app.component(fileName, GlobalComponents[fileName]);
});

app.use(store);
app.use(ElementPlus, { locale:itIT, size: "large" });
app.use(router);

// Use plugin defaults (optional)
app.use(setupCalendar, {})

// Use the components
app.component('VCalendar', Calendar)
app.component('VDatePicker', DatePicker)

ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();
setLocale(it);
dayjs.locale('it');
app.use(i18n);

app.mount("#app");
